define('OutSystems/ClientRuntime/EventDispatcher',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EventDispatcher = exports.TransitionEndResult = exports.EventType = void 0;
    var EventType;
    (function (EventType) {
        EventType[EventType["TransitionStart"] = 0] = "TransitionStart";
        EventType[EventType["TransitionEnd"] = 1] = "TransitionEnd";
        EventType[EventType["NavigationStart"] = 2] = "NavigationStart";
    })(EventType || (exports.EventType = EventType = {}));
    var TransitionEndResult;
    (function (TransitionEndResult) {
        TransitionEndResult[TransitionEndResult["Success"] = 0] = "Success";
        TransitionEndResult[TransitionEndResult["Failure"] = 1] = "Failure";
    })(TransitionEndResult || (exports.TransitionEndResult = TransitionEndResult = {}));
    var lastListenerId = 0;
    var listeners = (function () {
        var result = [];
        var eventsCount = Object.keys(EventType).length / 2;
        for (var i = 0; i < eventsCount; i++) {
            result.push({});
        }
        return result;
    })();
    var EventDispatcher;
    (function (EventDispatcher) {
        function getNewId() {
            return "_" + lastListenerId++;
        }
        function listen(eventType, callback, listenOnce) {
            if (listenOnce === void 0) { listenOnce = false; }
            var id = getNewId();
            listeners[eventType][id] = { listenOnce: listenOnce, callback: callback };
            return { type: eventType, id: id };
        }
        EventDispatcher.listen = listen;
        function listenOnce(eventType, callback) {
            return listen(eventType, callback, true);
        }
        EventDispatcher.listenOnce = listenOnce;
        function unregister(listenerId) {
            return listenerId && innerUnregister(listenerId.type, listenerId.id);
        }
        EventDispatcher.unregister = unregister;
        function innerUnregister(eventType, id) {
            return delete listeners[eventType][id];
        }
        function dispatch(evt) {
            var result = undefined;
            var eventListeners = listeners[evt.type];
            for (var listenerId in eventListeners) {
                var listener = eventListeners[listenerId];
                if (listener.listenOnce) {
                    innerUnregister(evt.type, listenerId);
                }
                var lastResult = listener.callback(evt.args);
                if (lastResult !== undefined) {
                    result = lastResult;
                }
            }
            return result;
        }
        EventDispatcher.dispatch = dispatch;
    })(EventDispatcher || (exports.EventDispatcher = EventDispatcher = {}));
});
//# sourceMappingURL=EventDispatcher.js.map;
